module.exports={
	"Scope": "Sample-List",
	"CoreEntity": "Sample",
	"TitleTemplate": "Samples",
	"Descriptors":
	{
		"LabControlNumber":
		{
			"Name": "PSID",
			"Hash": "PSID",
			"PictDashboard": {}
		},
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Sample Status",
			"Hash": "Status",
			"DefaultHidden": true,
			"PictDashboard":
			{
				"ValueTemplate": "{~SampleStatusName:Record.Payload.Status~}"
			}
		},
		"ReceivedFrom":
		{
			"Name": "Source",
			"Hash": "Source",
			"PictDashboard": {}
		},
		"IDMaterial":
		{
			"Name": "Material",
			"Hash": "Material",
			"PictDashboard": {}
		},
		"SourceLocation":
		{
			"Name": "Source Location",
			"Hash": "SourceLocation",
			"PictDashboard":
			{
				"ValueTemplate": "{~ParseSourceLocation:Record.Payload~}"
			}
		},
		"Extension.StorageLocation":
		{
			"Name": "Storage Location",
			"Hash": "StorageLocation",
			"PictDashboard": 
			{
				"ValueTemplate": "{~E:Location^Record.Payload.Extension.StorageLocation^Datum-Value-Name~}"
			}
		},
		"Extension.ReceivedDate":
		{
			"Name": "Received On",
			"Hash": "ReceivedOn",
			"PictDashboard":
			{
				"ValueTemplate": "{~DateFormatNoFallback:Record.Payload.Extension.ReceivedDate^MM/DD/YYYY~}"
			}
		},
		"CreatingIDUser":
		{
			"Name": "Logged By",
			"Hash": "LoggedBy",
			"PictDashboard": {}
		}
	}
}
